/* INVENTORY REPORT (2026-10-23) — the weekly S&OP inventory as a portal job. */
const en = {
  title: 'Global Inventory Report',
  mpSearch: 'Search…', mpSearchSku: 'SKU#, product or colour', mpN: '{{n}} selected', mpClear: 'Clear', mpAll: 'Tick all {{n}}', mpMore: '{{n}} more — type to narrow',
  sub: 'On hand and amount (USD at buying cost) per entity by the age of each stock layer, a snapshot every day as at the end of the day before. HUSA, HEMA, HPAC and in transit are read from NetSuite, HINC from SAP; the HJPN count and the EUSU list are uploaded weekly and carried to the days after. The Friday snapshots are the weeks of the working file.',
  weekdayFri: 'week', week: 'Day', newWeek: 'New', fromWorkingFile: 'from the working file', newWeekHint: 'A day to load (yesterday or before)', openWeek: 'Open this day', refresh: 'Read again', export: 'Export working file (Excel)',
  tab_dash: 'Dashboard', tab_loads: 'Loads', tab_layers: 'Layers', tab_transit: 'In transit', tab_class: 'Classification',
  loading: 'Loading…', nothingLoaded: 'Nothing is loaded for this day yet — open the Loads tab.', nothingHere: 'Nothing here.',
  type1: 'Brand / line', type2: 'FG / material', type3: 'Category', type4: 'Sub-category', type5: 'Family', type6: 'Big / Small OD', type7: 'Normal / consignment',
  all: 'All', clearFilters: 'Clear filters', onHand: 'On hand', pcs: 'pcs', amount: 'Amount', vsPrev: '{{d}} against {{week}}', atCost: 'USD at buying cost',
  over1y: 'Over 1 year', inTransit: 'In transit', unclassifiedNote: '{{n}} SKUs on hand carry no classification yet, so a filter above leaves them out — the Classification tab lists them.',
  byAge: 'By entity and age', entity: 'Entity', u90: 'Under 90 days', o90: 'Over 90 days', o180: 'Over 180 days', o1y: 'Over 1 year', total: 'Total', vsLastWeek: 'Δ amount vs last week',
  qty: 'Qty', amountUsd: 'Amount (USD)', notLoaded: 'not loaded', noAgeHint: 'Layers with no inbound date have no age; they count in the total only.', noAge: '{{n}} pcs with no age', agingPct: 'Ageing % of amount',
  top30: 'Top 30 SKUs by amount', topShare: 'The top 30 of {{entity}} hold {{amt}} — {{share}} of its inventory.', sku: 'SKU#', sap: 'SAP#', product: 'Product', color: 'Color', share: '% of entity',
  loadStarted: 'Load started — the table fills in as it finishes.', error: 'Error', uploaded: '{{n}} rows, {{qty}} pcs read',
  loadsHint: 'One load per source and day. A load again replaces the one before (kept, not deleted). NetSuite gives today\'s balance, so the day is worked out by undoing every movement dated or keyed after it. HJPN and EUSU come as weekly files; a day with no file of its own carries the latest file before it, aged to the day. Automatic loads: 07:00 takes yesterday as at its end; 17:00 takes today so far (taken again the next morning).',
  source: 'Source', status: 'Status', rows: 'Rows', excluded: 'Left out (rows / pcs)', by: 'By · when', action: 'Action',
  srcNetsuite: 'NetSuite (report 797)', srcTransit: 'NetSuite (in transit)', srcHinc: 'SAP (HINC ageing)', srcHjpn: 'HJPN count (file)', srcEusu: 'EUSU stock list (file)',
  st_ok: 'Loaded', st_running: 'Running', st_error: 'Error', st_none: 'Not loaded', st_legacy: 'Working file',
  excludedHint: 'Database.xlsx\'s rule: wrt, case, skin, "frame ", sms, sample, swatch card, a (W) part; HJPN also leaves out cost 0.',
  running: 'Running…', loadNetsuite: 'Load from NetSuite', loadSap: 'Load from SAP', loadTransit: 'Read in transit', upload: 'Upload file',
  rulesHint: 'Rates: NetSuite SGD ÷ 1.3, HINC KRW ÷ 1,350, HJPN JPY ÷ 145 (portal settings inventory.*). A layer with no receipt is dated 01/Jan/2023, as the working file does. Age is counted to the day of the snapshot.',
  showExcluded: 'Show the rows left out', layersCount: '{{n}} layers · {{qty}} pcs', inbound: 'Inbound', unitCost: 'Cost (USD)', age: 'Age (days)', bucket: 'Age', unclassified: 'Unclassified',
  excludedWhy: 'Left out because', inboundDefault: 'No receipt found — dated 01/Jan/2023', first3000: 'The first 3,000 of {{n}} are shown — narrow with a filter.', nOfN: '{{n}} of {{total}} rows',
  kind_po: 'PO on a shipment', kind_to: 'Transfer order', transitHint: 'In transit as at the day ({{day}}): PO lines on inbound shipments created by then and not received by then, read back from the shipments; transfer orders only when they were read the morning after (NetSuite keeps no history of them).',
  kind: 'Kind', location: 'Location', shipped: 'Shipped', received: 'Received', onTheWay: 'On its way', shipDate: 'Shipped on', expected: 'Expected',
  classSaved: '{{sku}} classified.', accepted: '{{n}} SKUs classified from the suggestions.',
  classHint: '{{n}} SKUs on hand this day have no classification ({{count}} are classified). A suggestion is learnt from the SKUs already classified with the same PLM product (collection, category, type, frame model); {{l1}} can be accepted at once.',
  acceptAll: 'Accept the {{n}} full suggestions', entities: 'Entities', suggested: 'Suggestion', sugL1: 'Same PLM product ({{share}})', sugL2: 'Same category only ({{share}}) — no family', sugNone: 'None — type it in',
  save: 'Save', allClassified: 'Every SKU on hand is classified.',
};
const ko = {
  title: 'Global Inventory Report',
  mpSearch: '검색…', mpSearchSku: 'SKU#, 제품명 또는 색상', mpN: '{{n}}개 선택', mpClear: '지우기', mpAll: '{{n}}개 모두 선택', mpMore: '{{n}}개 더 있음 — 입력해 좁히기',
  sub: '법인별 재고 수량과 금액(매입원가 USD)을 재고 레이어 연령별로 보여주며, 매일 전날 마감 기준으로 스냅샷을 남깁니다. HUSA·HEMA·HPAC·운송 중은 NetSuite, HINC는 SAP에서 읽고 HJPN 실사와 EUSU 목록은 주 1회 업로드해 이후 날짜로 이어집니다. 금요일 스냅샷이 작업 파일의 주차입니다.',
  weekdayFri: '주차', week: '일자', newWeek: '신규', fromWorkingFile: '작업 파일에서', newWeekHint: '적재할 날짜(어제 또는 이전)', openWeek: '이 날짜 열기', refresh: '다시 읽기', export: '작업 파일 내보내기 (Excel)',
  tab_dash: '대시보드', tab_loads: '적재', tab_layers: '레이어', tab_transit: '운송 중', tab_class: '분류',
  loading: '불러오는 중…', nothingLoaded: '이 날짜에 적재된 데이터가 없습니다 — 적재 탭을 여세요.', nothingHere: '없음.',
  type1: '브랜드 / 라인', type2: '완제품 / 자재', type3: '카테고리', type4: '하위 카테고리', type5: '패밀리', type6: 'Big / Small OD', type7: '일반 / 위탁',
  all: '전체', clearFilters: '필터 지우기', onHand: '재고', pcs: '개', amount: '금액', vsPrev: '{{week}} 대비 {{d}}', atCost: '매입원가 USD',
  over1y: '1년 초과', inTransit: '운송 중', unclassifiedNote: '재고 중 {{n}}개 SKU에 분류가 없어 위 필터에서 빠집니다 — 분류 탭에 있습니다.',
  byAge: '법인 및 연령별', entity: '법인', u90: '90일 미만', o90: '90일 초과', o180: '180일 초과', o1y: '1년 초과', total: '합계', vsLastWeek: '전주 대비 금액 Δ',
  qty: '수량', amountUsd: '금액 (USD)', notLoaded: '미적재', noAgeHint: '입고일이 없는 레이어는 연령이 없어 합계에만 포함됩니다.', noAge: '연령 없음 {{n}}개', agingPct: '금액 기준 연령 %',
  top30: '금액 상위 30 SKU', topShare: '{{entity}} 상위 30개가 {{amt}} — 재고의 {{share}}를 차지합니다.', sku: 'SKU#', sap: 'SAP#', product: '제품', color: '색상', share: '법인 대비 %',
  loadStarted: '적재 시작 — 완료되면 표가 채워집니다.', error: '오류', uploaded: '{{n}}행, {{qty}}개 읽음',
  loadsHint: '출처와 날짜마다 적재 1건. 다시 적재하면 이전 적재를 대체합니다(삭제하지 않고 보관). NetSuite는 오늘 잔고만 주므로, 그날 이후 날짜 또는 이후 입력된 모든 거래를 되돌려 계산합니다. HJPN과 EUSU는 주간 파일이며, 파일이 없는 날은 그 전 최신 파일을 그날 기준 연령으로 이어 씁니다. 자동 적재: 07:00에 전날 마감 기준, 17:00에 오늘 현재까지(다음 날 아침 다시 적재).',
  source: '출처', status: '상태', rows: '행', excluded: '제외 (행 / 개)', by: '담당 · 시각', action: '작업',
  srcNetsuite: 'NetSuite (리포트 797)', srcTransit: 'NetSuite (운송 중)', srcHinc: 'SAP (HINC 에이징)', srcHjpn: 'HJPN 실사 (파일)', srcEusu: 'EUSU 재고 목록 (파일)',
  st_ok: '적재됨', st_running: '진행 중', st_error: '오류', st_none: '미적재', st_legacy: '작업 파일',
  excludedHint: 'Database.xlsx 규칙: wrt, case, skin, "frame ", sms, sample, swatch card, (W) 부품; HJPN은 원가 0도 제외.',
  running: '진행 중…', loadNetsuite: 'NetSuite에서 적재', loadSap: 'SAP에서 적재', loadTransit: '운송 중 읽기', upload: '파일 업로드',
  rulesHint: '환율: NetSuite SGD ÷ 1.3, HINC KRW ÷ 1,350, HJPN JPY ÷ 145 (포털 설정 inventory.*). 입고 기록이 없는 레이어는 작업 파일처럼 2023-01-01로 봅니다. 연령은 스냅샷 날짜 기준입니다.',
  showExcluded: '제외된 행 보기', layersCount: '레이어 {{n}}개 · {{qty}}개', inbound: '입고일', unitCost: '원가 (USD)', age: '연령 (일)', bucket: '연령', unclassified: '미분류',
  excludedWhy: '제외 사유', inboundDefault: '입고 기록 없음 — 2023-01-01로 봄', first3000: '{{n}}개 중 처음 3,000개만 표시 — 필터로 좁히세요.', nOfN: '{{total}}행 중 {{n}}행',
  kind_po: '선적 중 PO', kind_to: '이동 주문', transitHint: '그날({{day}}) 기준 운송 중: 그날까지 생성되고 그날까지 입고되지 않은 입고 선적의 PO 라인(선적 기록에서 되읽음). 이동 주문은 다음 날 아침에 읽은 경우에만 포함됩니다(NetSuite가 이력을 남기지 않음).',
  kind: '종류', location: '위치', shipped: '선적', received: '입고', onTheWay: '운송 중', shipDate: '선적일', expected: '예정일',
  classSaved: '{{sku}} 분류 저장.', accepted: '제안으로 {{n}}개 SKU 분류.',
  classHint: '이 날짜 재고 중 {{n}}개 SKU에 분류가 없습니다(분류 완료 {{count}}개). 같은 PLM 제품(컬렉션, 카테고리, 타입, 프레임 모델)의 기존 분류에서 제안을 만들며, {{l1}}개는 바로 수락할 수 있습니다.',
  acceptAll: '전체 제안 {{n}}개 수락', entities: '법인', suggested: '제안', sugL1: '같은 PLM 제품 ({{share}})', sugL2: '같은 카테고리만 ({{share}}) — 패밀리 없음', sugNone: '없음 — 직접 입력',
  save: '저장', allClassified: '재고의 모든 SKU가 분류되었습니다.',
};
const vi = {
  title: 'Global Inventory Report',
  mpSearch: 'Tìm…', mpSearchSku: 'SKU#, tên sản phẩm hoặc màu', mpN: 'Đã chọn {{n}}', mpClear: 'Bỏ chọn', mpAll: 'Chọn cả {{n}}', mpMore: 'Còn {{n}} nữa — gõ để lọc',
  sub: 'Tồn kho và giá trị (USD theo giá mua) theo từng entity và tuổi của từng lớp hàng, chụp mỗi ngày theo số cuối ngày hôm trước. HUSA, HEMA, HPAC và hàng đang về đọc từ NetSuite, HINC từ SAP; file kiểm kê HJPN và danh sách EUSU upload hằng tuần và được dùng tiếp cho các ngày sau. Ảnh chụp thứ Sáu là các tuần của working file.',
  weekdayFri: 'tuần', week: 'Ngày', newWeek: 'Mới', fromWorkingFile: 'từ working file', newWeekHint: 'Ngày cần nạp (hôm qua hoặc trước đó)', openWeek: 'Mở ngày này', refresh: 'Đọc lại', export: 'Xuất working file (Excel)',
  tab_dash: 'Dashboard', tab_loads: 'Nạp dữ liệu', tab_layers: 'Lớp hàng', tab_transit: 'Hàng đang về', tab_class: 'Phân loại',
  loading: 'Đang tải…', nothingLoaded: 'Ngày này chưa nạp gì — mở tab Nạp dữ liệu.', nothingHere: 'Không có gì.',
  type1: 'Brand / line', type2: 'FG / nguyên liệu', type3: 'Category', type4: 'Sub-category', type5: 'Family', type6: 'Big / Small OD', type7: 'Thường / ký gửi',
  all: 'Tất cả', clearFilters: 'Bỏ lọc', onHand: 'Tồn kho', pcs: 'cái', amount: 'Giá trị', vsPrev: '{{d}} so với {{week}}', atCost: 'USD theo giá mua',
  over1y: 'Trên 1 năm', inTransit: 'Hàng đang về', unclassifiedNote: '{{n}} SKU đang tồn chưa có phân loại nên bộ lọc ở trên không tính — tab Phân loại liệt kê chúng.',
  byAge: 'Theo entity và tuổi', entity: 'Entity', u90: 'Dưới 90 ngày', o90: 'Trên 90 ngày', o180: 'Trên 180 ngày', o1y: 'Trên 1 năm', total: 'Tổng', vsLastWeek: 'Δ giá trị so với tuần trước',
  qty: 'SL', amountUsd: 'Giá trị (USD)', notLoaded: 'chưa nạp', noAgeHint: 'Lớp hàng không có ngày nhập thì không có tuổi; chỉ tính vào tổng.', noAge: '{{n}} cái không có tuổi', agingPct: '% giá trị theo tuổi',
  top30: 'Top 30 SKU theo giá trị', topShare: 'Top 30 của {{entity}} giữ {{amt}} — {{share}} tồn kho của entity.', sku: 'SKU#', sap: 'SAP#', product: 'Sản phẩm', color: 'Màu', share: '% của entity',
  loadStarted: 'Đã bắt đầu nạp — bảng sẽ có số khi xong.', error: 'Lỗi', uploaded: 'đọc {{n}} dòng, {{qty}} cái',
  loadsHint: 'Mỗi nguồn mỗi ngày có một lần nạp. Nạp lại sẽ thay lần trước (lần trước vẫn được giữ, không xóa). NetSuite chỉ cho tồn hôm nay, nên tồn của ngày được tính bằng cách trừ ngược mọi giao dịch có ngày hoặc được nhập sau ngày đó. HJPN và EUSU là file theo tuần; ngày nào không có file riêng thì dùng file gần nhất trước đó, tính lại tuổi theo ngày. Nạp tự động: 07:00 lấy ngày hôm qua theo số cuối ngày; 17:00 lấy hôm nay tới thời điểm đó (sáng hôm sau nạp lại).',
  source: 'Nguồn', status: 'Trạng thái', rows: 'Dòng', excluded: 'Loại ra (dòng / cái)', by: 'Người · lúc', action: 'Thao tác',
  srcNetsuite: 'NetSuite (report 797)', srcTransit: 'NetSuite (hàng đang về)', srcHinc: 'SAP (HINC ageing)', srcHjpn: 'Kiểm kê HJPN (file)', srcEusu: 'Danh sách tồn EUSU (file)',
  st_ok: 'Đã nạp', st_running: 'Đang chạy', st_error: 'Lỗi', st_none: 'Chưa nạp', st_legacy: 'Working file',
  excludedHint: 'Quy tắc của Database.xlsx: wrt, case, skin, "frame ", sms, sample, swatch card, phụ tùng (W); HJPN loại thêm dòng giá 0.',
  running: 'Đang chạy…', loadNetsuite: 'Nạp từ NetSuite', loadSap: 'Nạp từ SAP', loadTransit: 'Đọc hàng đang về', upload: 'Upload file',
  rulesHint: 'Tỷ giá: NetSuite SGD ÷ 1,3, HINC KRW ÷ 1.350, HJPN JPY ÷ 145 (cài đặt inventory.*). Lớp hàng không tìm thấy phiếu nhập được tính ngày 01/01/2023 như working file. Tuổi tính đến ngày chụp.',
  showExcluded: 'Hiện các dòng bị loại', layersCount: '{{n}} lớp · {{qty}} cái', inbound: 'Ngày nhập', unitCost: 'Giá (USD)', age: 'Tuổi (ngày)', bucket: 'Tuổi', unclassified: 'Chưa phân loại',
  excludedWhy: 'Lý do loại', inboundDefault: 'Không có phiếu nhập — tính ngày 01/01/2023', first3000: 'Chỉ hiện 3.000 dòng đầu trong {{n}} — dùng bộ lọc để thu hẹp.', nOfN: '{{n}} / {{total}} dòng',
  kind_po: 'PO trên lô hàng', kind_to: 'Lệnh chuyển kho', transitHint: 'Hàng đang về tính đến ngày ({{day}}): dòng PO trên inbound shipment tạo đến ngày đó và chưa nhận đến ngày đó, đọc ngược từ shipment; lệnh chuyển kho chỉ có khi được đọc vào sáng hôm sau (NetSuite không lưu lịch sử).',
  kind: 'Loại', location: 'Kho', shipped: 'Đã gửi', received: 'Đã nhận', onTheWay: 'Đang về', shipDate: 'Ngày gửi', expected: 'Dự kiến',
  classSaved: 'Đã phân loại {{sku}}.', accepted: 'Đã phân loại {{n}} SKU theo gợi ý.',
  classHint: '{{n}} SKU đang tồn ngày này chưa có phân loại ({{count}} SKU đã có). Gợi ý được học từ các SKU đã phân loại có cùng sản phẩm PLM (collection, category, type, frame model); {{l1}} SKU có thể chấp nhận ngay.',
  acceptAll: 'Chấp nhận {{n}} gợi ý đầy đủ', entities: 'Entity', suggested: 'Gợi ý', sugL1: 'Cùng sản phẩm PLM ({{share}})', sugL2: 'Chỉ cùng category ({{share}}) — chưa có family', sugNone: 'Không có — tự điền',
  save: 'Lưu', allClassified: 'Mọi SKU đang tồn đã có phân loại.',
};
const zh = {
  title: 'Global Inventory Report',
  mpSearch: '搜索…', mpSearchSku: 'SKU#、产品名或颜色', mpN: '已选 {{n}} 个', mpClear: '清除', mpAll: '全选 {{n}} 个', mpMore: '还有 {{n}} 个 — 输入以缩小范围',
  sub: '按法人和每个库存批次的库龄显示库存数量与金额（采购成本 USD），每天以前一天日终为准保存快照。HUSA、HEMA、HPAC 和在途从 NetSuite 读取，HINC 从 SAP；HJPN 盘点和 EUSU 清单每周上传并沿用到之后的日期。周五快照即工作文件的周。',
  weekdayFri: '周', week: '日期', newWeek: '新', fromWorkingFile: '来自工作文件', newWeekHint: '要加载的日期（昨天或更早）', openWeek: '打开此日期', refresh: '重新读取', export: '导出工作文件（Excel）',
  tab_dash: '仪表板', tab_loads: '加载', tab_layers: '批次', tab_transit: '在途', tab_class: '分类',
  loading: '加载中…', nothingLoaded: '此日期尚未加载 — 请打开“加载”标签。', nothingHere: '无内容。',
  type1: '品牌 / 系列', type2: '成品 / 物料', type3: '类别', type4: '子类别', type5: '系列族', type6: 'Big / Small OD', type7: '普通 / 寄售',
  all: '全部', clearFilters: '清除筛选', onHand: '库存', pcs: '件', amount: '金额', vsPrev: '较 {{week}} {{d}}', atCost: '采购成本 USD',
  over1y: '超过 1 年', inTransit: '在途', unclassifiedNote: '库存中有 {{n}} 个 SKU 尚无分类，上方筛选不包含它们 — 见“分类”标签。',
  byAge: '按法人和库龄', entity: '法人', u90: '90 天以内', o90: '超过 90 天', o180: '超过 180 天', o1y: '超过 1 年', total: '合计', vsLastWeek: '较上周金额 Δ',
  qty: '数量', amountUsd: '金额 (USD)', notLoaded: '未加载', noAgeHint: '没有入库日期的批次没有库龄，只计入合计。', noAge: '{{n}} 件无库龄', agingPct: '金额库龄 %',
  top30: '金额前 30 SKU', topShare: '{{entity}} 前 30 个占 {{amt}} — 其库存的 {{share}}。', sku: 'SKU#', sap: 'SAP#', product: '产品', color: '颜色', share: '占法人 %',
  loadStarted: '已开始加载 — 完成后表格会显示。', error: '错误', uploaded: '读取 {{n}} 行，{{qty}} 件',
  loadsHint: '每个来源每天一次加载。再次加载会替换上一次（保留，不删除）。NetSuite 只提供当前余额，因此当天数据通过撤销当天之后日期或之后录入的所有业务计算得出。HJPN 和 EUSU 为每周文件；没有当天文件时沿用之前最新的文件，并按当天重算库龄。自动加载：07:00 加载前一天日终数据；17:00 加载今天截至当时的数据（次日早上重新加载）。',
  source: '来源', status: '状态', rows: '行', excluded: '排除（行 / 件）', by: '操作人 · 时间', action: '操作',
  srcNetsuite: 'NetSuite（报表 797）', srcTransit: 'NetSuite（在途）', srcHinc: 'SAP（HINC 库龄）', srcHjpn: 'HJPN 盘点（文件）', srcEusu: 'EUSU 库存清单（文件）',
  st_ok: '已加载', st_running: '运行中', st_error: '错误', st_none: '未加载', st_legacy: '工作文件',
  excludedHint: 'Database.xlsx 规则：wrt、case、skin、"frame "、sms、sample、swatch card、(W) 部件；HJPN 另排除成本为 0 的行。',
  running: '运行中…', loadNetsuite: '从 NetSuite 加载', loadSap: '从 SAP 加载', loadTransit: '读取在途', upload: '上传文件',
  rulesHint: '汇率：NetSuite SGD ÷ 1.3，HINC KRW ÷ 1,350，HJPN JPY ÷ 145（门户设置 inventory.*）。找不到入库单的批次按工作文件记为 2023-01-01。库龄计算到快照日期。',
  showExcluded: '显示排除的行', layersCount: '{{n}} 个批次 · {{qty}} 件', inbound: '入库日', unitCost: '成本 (USD)', age: '库龄（天）', bucket: '库龄', unclassified: '未分类',
  excludedWhy: '排除原因', inboundDefault: '无入库单 — 记为 2023-01-01', first3000: '{{n}} 行中只显示前 3,000 行 — 请用筛选缩小范围。', nOfN: '{{total}} 行中的 {{n}} 行',
  kind_po: '在途货运上的 PO', kind_to: '调拨单', transitHint: '截至当天（{{day}}）的在途：当天前创建且当天前未收货的入库货运 PO 行（从货运记录回溯）；调拨单仅在次日早上读取时包含（NetSuite 不保存其历史）。',
  kind: '类型', location: '仓库', shipped: '已发', received: '已收', onTheWay: '在途', shipDate: '发货日', expected: '预计',
  classSaved: '{{sku}} 已分类。', accepted: '按建议分类了 {{n}} 个 SKU。',
  classHint: '此日期库存中有 {{n}} 个 SKU 没有分类（已分类 {{count}} 个）。建议取自同一 PLM 产品（系列、类别、类型、框架型号）已分类的 SKU；{{l1}} 个可直接接受。',
  acceptAll: '接受 {{n}} 个完整建议', entities: '法人', suggested: '建议', sugL1: '同一 PLM 产品（{{share}}）', sugL2: '仅同一类别（{{share}}）— 无系列族', sugNone: '无 — 请手动填写',
  save: '保存', allClassified: '所有库存 SKU 都已分类。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "title": "Global Inventory Report",
  "mpSearch": "Rechercher…",
  "mpSearchSku": "SKU#, produit ou couleur",
  "mpN": "{{n}} sélectionné(s)",
  "mpClear": "Effacer",
  "mpAll": "Tout cocher ({{n}})",
  "mpMore": "{{n}} de plus — saisissez pour affiner",
  "sub": "Quantité en stock et montant (USD au coût d’achat) par entité selon l’ancienneté de chaque couche de stock, avec un instantané chaque jour à la fin de la veille. HUSA, HEMA, HPAC et le stock en transit sont lus depuis NetSuite, HINC depuis SAP ; le comptage HJPN et la liste EUSU sont importés chaque semaine et reportés sur les jours suivants. Les instantanés du vendredi correspondent aux semaines du working file.",
  "weekdayFri": "semaine",
  "week": "Jour",
  "newWeek": "Nouveau",
  "fromWorkingFile": "du working file",
  "newWeekHint": "Un jour à charger (hier ou avant)",
  "openWeek": "Ouvrir ce jour",
  "refresh": "Relire",
  "export": "Exporter le working file (Excel)",
  "tab_dash": "Tableau de bord",
  "tab_loads": "Chargements",
  "tab_layers": "Couches",
  "tab_transit": "En transit",
  "tab_class": "Classification",
  "loading": "Chargement…",
  "nothingLoaded": "Rien n’est encore chargé pour ce jour — ouvrez l’onglet Chargements.",
  "nothingHere": "Rien ici.",
  "type1": "Marque / ligne",
  "type2": "FG / matière",
  "type3": "Catégorie",
  "type4": "Sous-catégorie",
  "type5": "Famille",
  "type6": "Big / Small OD",
  "type7": "Normal / consignation",
  "all": "Tout",
  "clearFilters": "Effacer les filtres",
  "onHand": "En stock",
  "pcs": "pcs",
  "amount": "Montant",
  "vsPrev": "{{d}} par rapport à {{week}}",
  "atCost": "USD au coût d’achat",
  "over1y": "Plus d’1 an",
  "inTransit": "En transit",
  "unclassifiedNote": "{{n}} SKU en stock n’ont pas encore de classification et sont donc exclus par un filtre ci-dessus — l’onglet Classification les liste.",
  "byAge": "Par entité et ancienneté",
  "entity": "Entité",
  "u90": "Moins de 90 jours",
  "o90": "Plus de 90 jours",
  "o180": "Plus de 180 jours",
  "o1y": "Plus d’1 an",
  "total": "Total",
  "vsLastWeek": "Δ montant vs semaine dernière",
  "qty": "Qté",
  "amountUsd": "Montant (USD)",
  "notLoaded": "non chargé",
  "noAgeHint": "Les couches sans date d’entrée n’ont pas d’ancienneté ; elles ne comptent que dans le total.",
  "noAge": "{{n}} pcs sans ancienneté",
  "agingPct": "Vieillissement en % du montant",
  "top30": "Top 30 des SKU par montant",
  "topShare": "Les 30 premiers de {{entity}} représentent {{amt}} — {{share}} de son stock.",
  "sku": "SKU#",
  "sap": "SAP#",
  "product": "Produit",
  "color": "Couleur",
  "share": "% de l’entité",
  "loadStarted": "Chargement lancé — le tableau se remplit au fur et à mesure.",
  "error": "Erreur",
  "uploaded": "{{n}} lignes, {{qty}} pcs lues",
  "loadsHint": "Un chargement par source et par jour. Un nouveau chargement remplace le précédent (conservé, non supprimé). NetSuite fournit le solde du jour : la situation d’un jour donné est donc reconstituée en annulant tous les mouvements datés ou saisis après lui. HJPN et EUSU arrivent sous forme de fichiers hebdomadaires ; un jour sans fichier propre reprend le dernier fichier antérieur, vieilli au jour près. Chargements automatiques : 07:00 prend la veille à sa clôture ; 17:00 prend la journée en cours (repris le lendemain matin).",
  "source": "Source",
  "status": "Statut",
  "rows": "Lignes",
  "excluded": "Exclues (lignes / pcs)",
  "by": "Par · quand",
  "action": "Action",
  "srcNetsuite": "NetSuite (rapport 797)",
  "srcTransit": "NetSuite (en transit)",
  "srcHinc": "SAP (ancienneté HINC)",
  "srcHjpn": "Comptage HJPN (fichier)",
  "srcEusu": "Liste de stock EUSU (fichier)",
  "st_ok": "Chargé",
  "st_running": "En cours",
  "st_error": "Erreur",
  "st_none": "Non chargé",
  "st_legacy": "Working file",
  "excludedHint": "Règle de Database.xlsx : wrt, case, skin, \"frame \", sms, sample, swatch card, une pièce (W) ; HJPN exclut aussi les coûts à 0.",
  "running": "En cours…",
  "loadNetsuite": "Charger depuis NetSuite",
  "loadSap": "Charger depuis SAP",
  "loadTransit": "Lire le stock en transit",
  "upload": "Importer un fichier",
  "rulesHint": "Taux : NetSuite SGD ÷ 1.3, HINC KRW ÷ 1,350, HJPN JPY ÷ 145 (paramètres du portail inventory.*). Une couche sans réception est datée du 01/Jan/2023, comme dans le working file. L’ancienneté est calculée jusqu’au jour de l’instantané.",
  "showExcluded": "Afficher les lignes exclues",
  "layersCount": "{{n}} couches · {{qty}} pcs",
  "inbound": "Entrée",
  "unitCost": "Coût (USD)",
  "age": "Ancienneté (jours)",
  "bucket": "Ancienneté",
  "unclassified": "Non classé",
  "excludedWhy": "Exclue car",
  "inboundDefault": "Aucune réception trouvée — daté du 01/Jan/2023",
  "first3000": "Les 3,000 premières sur {{n}} sont affichées — affinez avec un filtre.",
  "nOfN": "{{n}} lignes sur {{total}}",
  "kind_po": "PO sur une expédition",
  "kind_to": "Ordre de transfert",
  "transitHint": "En transit au jour indiqué ({{day}}) : lignes de PO des expéditions entrantes créées à cette date et non reçues à cette date, relues depuis les expéditions ; les ordres de transfert uniquement s’ils ont été lus le lendemain matin (NetSuite n’en conserve aucun historique).",
  "kind": "Type",
  "location": "Emplacement",
  "shipped": "Expédié",
  "received": "Reçu",
  "onTheWay": "En route",
  "shipDate": "Expédié le",
  "expected": "Prévu",
  "classSaved": "{{sku}} classé.",
  "accepted": "{{n}} SKU classés à partir des suggestions.",
  "classHint": "{{n}} SKU en stock ce jour-là n’ont pas de classification ({{count}} sont classés). Une suggestion est déduite des SKU déjà classés ayant le même produit PLM (collection, catégorie, type, modèle de cadre) ; {{l1}} peuvent être acceptées d’un coup.",
  "acceptAll": "Accepter les {{n}} suggestions complètes",
  "entities": "Entités",
  "suggested": "Suggestion",
  "sugL1": "Même produit PLM ({{share}})",
  "sugL2": "Même catégorie uniquement ({{share}}) — pas de famille",
  "sugNone": "Aucune — saisissez-la",
  "save": "Enregistrer",
  "allClassified": "Tous les SKU en stock sont classés."
};
const ja = {
  "title": "Global Inventory Report",
  "mpSearch": "検索…",
  "mpSearchSku": "SKU#、商品名、色",
  "mpN": "{{n}}件選択中",
  "mpClear": "クリア",
  "mpAll": "{{n}}件すべてにチェック",
  "mpMore": "ほか{{n}}件 — 入力して絞り込み",
  "sub": "エンティティ別の在庫数量と金額（仕入原価ベースのUSD）を、在庫レイヤーの経過期間別に表示します。毎日、前日終了時点のスナップショットを取得します。HUSA、HEMA、HPAC、輸送中はNetSuite、HINCはSAPから読み込みます。HJPNのカウントとEUSUのリストは毎週アップロードされ、以降の日にも引き継がれます。金曜日のスナップショットが、working fileの各週に相当します。",
  "weekdayFri": "週",
  "week": "日付",
  "newWeek": "新規",
  "fromWorkingFile": "working fileより",
  "newWeekHint": "読み込む日付（昨日以前）",
  "openWeek": "この日付を開く",
  "refresh": "再読み込み",
  "export": "working fileをエクスポート（Excel）",
  "tab_dash": "ダッシュボード",
  "tab_loads": "読み込み",
  "tab_layers": "レイヤー",
  "tab_transit": "輸送中",
  "tab_class": "分類",
  "loading": "読み込み中…",
  "nothingLoaded": "この日付のデータはまだ読み込まれていません。「読み込み」タブを開いてください。",
  "nothingHere": "データがありません。",
  "type1": "ブランド / ライン",
  "type2": "FG / 原材料",
  "type3": "カテゴリー",
  "type4": "サブカテゴリー",
  "type5": "ファミリー",
  "type6": "Big / Small OD",
  "type7": "通常 / 委託",
  "all": "すべて",
  "clearFilters": "フィルターをクリア",
  "onHand": "在庫数",
  "pcs": "pcs",
  "amount": "金額",
  "vsPrev": "{{week}}比 {{d}}",
  "atCost": "仕入原価ベースのUSD",
  "over1y": "1年超",
  "inTransit": "輸送中",
  "unclassifiedNote": "在庫のある{{n}}件のSKUにはまだ分類がないため、上のフィルターを使うと除外されます。該当SKUは「分類」タブに一覧表示されます。",
  "byAge": "エンティティ別・経過期間別",
  "entity": "エンティティ",
  "u90": "90日未満",
  "o90": "90日超",
  "o180": "180日超",
  "o1y": "1年超",
  "total": "合計",
  "vsLastWeek": "先週比の金額差（Δ）",
  "qty": "数量",
  "amountUsd": "金額（USD）",
  "notLoaded": "未読み込み",
  "noAgeHint": "入庫日のないレイヤーには経過期間がないため、合計にのみ含まれます。",
  "noAge": "経過期間なし：{{n}} pcs",
  "agingPct": "金額に占める滞留割合（%）",
  "top30": "金額上位30 SKU",
  "topShare": "{{entity}}の上位30件で{{amt}}となり、同社在庫の{{share}}を占めます。",
  "sku": "SKU#",
  "sap": "SAP#",
  "product": "商品",
  "color": "色",
  "share": "エンティティ内の割合（%）",
  "loadStarted": "読み込みを開始しました。完了するにつれて表が埋まります。",
  "error": "エラー",
  "uploaded": "{{n}}行、{{qty}} pcsを読み込みました",
  "loadsHint": "読み込みはソースごと、日付ごとに1回です。再度読み込むと前回分を置き換えます（前回分は削除されず保持されます）。NetSuiteからは当日の残高が取得されるため、その日付より後の日付または入力の動きをすべて取り消して、当日の在庫を算出します。HJPNとEUSUは週次ファイルで届き、自分のファイルがない日は、それより前の最新ファイルを日付に合わせて経過日数を進めて引き継ぎます。自動読み込み：07:00は前日の終了時点、17:00は当日のここまでを取得します（翌朝にもう一度取得します）。",
  "source": "ソース",
  "status": "ステータス",
  "rows": "行数",
  "excluded": "除外（行 / pcs）",
  "by": "実行者 · 日時",
  "action": "操作",
  "srcNetsuite": "NetSuite（レポート797）",
  "srcTransit": "NetSuite（輸送中）",
  "srcHinc": "SAP（HINCエイジング）",
  "srcHjpn": "HJPNカウント（ファイル）",
  "srcEusu": "EUSU在庫リスト（ファイル）",
  "st_ok": "読み込み済み",
  "st_running": "実行中",
  "st_error": "エラー",
  "st_none": "未読み込み",
  "st_legacy": "Working file",
  "excludedHint": "Database.xlsxのルール：wrt、case、skin、\"frame \"、sms、sample、swatch card、(W)の部品。HJPNはコスト0も除外します。",
  "running": "実行中…",
  "loadNetsuite": "NetSuiteから読み込み",
  "loadSap": "SAPから読み込み",
  "loadTransit": "輸送中を読み込み",
  "upload": "ファイルをアップロード",
  "rulesHint": "レート：NetSuite SGD ÷ 1.3、HINC KRW ÷ 1,350、HJPN JPY ÷ 145（ポータル設定 inventory.*）。入庫記録のないレイヤーは、working fileと同様に01/Jan/2023の日付として扱います。経過期間はスナップショットの日付まで数えます。",
  "showExcluded": "除外された行を表示",
  "layersCount": "{{n}}レイヤー · {{qty}} pcs",
  "inbound": "入庫",
  "unitCost": "コスト（USD）",
  "age": "経過日数",
  "bucket": "経過期間",
  "unclassified": "未分類",
  "excludedWhy": "除外の理由",
  "inboundDefault": "入庫記録なし — 01/Jan/2023の日付として扱います",
  "first3000": "{{n}}件のうち先頭の3,000件を表示しています。フィルターで絞り込んでください。",
  "nOfN": "{{total}}行中{{n}}行",
  "kind_po": "出荷中のPO",
  "kind_to": "移動オーダー",
  "transitHint": "{{day}}時点の輸送中：その日までに作成され、その日までに受領されていない入荷出荷分のPOライン（出荷情報から再取得）。移動オーダーは、翌朝に読み込んだ場合のみ対象です（NetSuiteには移動オーダーの履歴が残らないため）。",
  "kind": "種別",
  "location": "保管場所",
  "shipped": "出荷済み",
  "received": "受領済み",
  "onTheWay": "輸送中",
  "shipDate": "出荷日",
  "expected": "到着予定",
  "classSaved": "{{sku}}を分類しました。",
  "accepted": "候補をもとに{{n}}件のSKUを分類しました。",
  "classHint": "この日に在庫のある{{n}}件のSKUには分類がありません（分類済みは{{count}}件）。候補は、同じPLM商品（コレクション、カテゴリー、タイプ、フレームモデル）ですでに分類されているSKUから導き出されます。{{l1}}件はまとめて承認できます。",
  "acceptAll": "完全一致の候補{{n}}件をすべて承認",
  "entities": "エンティティ",
  "suggested": "候補",
  "sugL1": "同じPLM商品（{{share}}）",
  "sugL2": "同じカテゴリーのみ（{{share}}）— ファミリーなし",
  "sugNone": "なし — 直接入力してください",
  "save": "保存",
  "allClassified": "在庫のあるすべてのSKUが分類済みです。"
};

export default { ns: 'xInventory', en, ko, vi, zh, fr, ja };
